module.exports = __webpack_public_path__ + "img/9788982731938.9e7e8858.jpg";